var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { DateTime } from 'luxon';
import { isMobileOnly } from 'react-device-detect';
import { RETURN_METHOD, } from '../constants/general';
import { getCookieValue } from './cookie-helper';
import { FlowDropOffBoxesStep, FlowFinalizeReturnStep, FlowItemsToReturnStep, FlowLORPContactDetailsStep, FlowLORPUserAcknowledgeStep, FlowLORPWhatToExpectStep, FlowRefundMethodStep, FlowReturnMethodStep, } from '../constants';
// set of protected feature switches not allowed to be overwritten by a cookie
var PROTECTED_FS_SET = new Set(['boxesPerItem']);
export var isFeatureSwitchEnabled = function (instance, featureSwitchName) {
    var _a;
    if (instance === void 0) { instance = {}; }
    if (featureSwitchName === void 0) { featureSwitchName = ''; }
    if (!instance)
        return false;
    var validTrueInput = new Set(['true', '1']);
    var validFalseInput = new Set(['false', '0']);
    var isProd = window.location.hostname === 'www.homedepot.com';
    var isFSProtected = isProd && PROTECTED_FS_SET.has(featureSwitchName);
    if (!isFSProtected) {
        // Check cookies first
        var cookieValue = getCookieValue(featureSwitchName);
        if (cookieValue !== undefined) {
            if (validTrueInput.has(cookieValue))
                return true;
            if (validFalseInput.has(cookieValue))
                return false;
        }
    }
    var featureSwitchValue = (_a = instance === null || instance === void 0 ? void 0 : instance.expConfiguration) === null || _a === void 0 ? void 0 : _a[featureSwitchName];
    return validTrueInput.has(featureSwitchValue);
};
// Used when instance variable is not available in non-hooks
export var getFeatureSwitchStatic = function (featureSwitchName, isBoolean, serverDefault) {
    var _a, _b;
    if (isBoolean === void 0) { isBoolean = true; }
    if (serverDefault === void 0) { serverDefault = false; }
    // if true, will return true in initial server rendering. Otherwise getWindow() will fail and return false.
    if (!getWindow() && serverDefault)
        return serverDefault;
    if (!getWindow())
        return false;
    var validTrueInput = new Set(['true', '1']);
    var validFalseInput = new Set(['false', '0']);
    var isProd = (window === null || window === void 0 ? void 0 : window.location.hostname) === 'www.homedepot.com';
    var isFSProtected = isProd && PROTECTED_FS_SET.has(featureSwitchName);
    if (!isFSProtected) {
        // Check cookies first
        var cookieValue = getCookieValue(featureSwitchName);
        if (cookieValue !== undefined) {
            if (isBoolean) {
                if (validTrueInput.has(cookieValue))
                    return true;
                if (validFalseInput.has(cookieValue))
                    return false;
            }
            return cookieValue;
        }
    }
    var featureSwitchValue = (_b = (_a = window === null || window === void 0 ? void 0 : window.__EXPERIENCE_PROPS__) === null || _a === void 0 ? void 0 : _a.expConfiguration) === null || _b === void 0 ? void 0 : _b[featureSwitchName];
    if (isBoolean)
        return validTrueInput.has(featureSwitchValue);
    return featureSwitchValue;
};
export var isSsr = typeof window === 'undefined';
export var getHost = function () {
    if (isSsr)
        return '';
    if (process.env.NODE_ENV === 'production' && !process.env.DOMAIN_NAME) {
        return "https://".concat(window.location.hostname);
    }
    return window.location.origin;
};
export var getChannelID = function () { return (isMobileOnly ? 2 : 1); };
export var generateXB3TraceID = function () {
    return Math.random().toString(16).substring(2) +
        new Date().getTime().toString(16).substring(0, 15);
};
// CorrelationId used to correlate multiple requests sent during the same session
export var SESSION_CORRELATION_ID = generateXB3TraceID();
export var getUrlParam = function (key) {
    var _a;
    var searchParams = typeof window !== 'undefined' ? (_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.search : '';
    var urlParams = new URLSearchParams(searchParams);
    return urlParams.get(key);
};
export var getTmxId = function () {
    var _a, _b, _c;
    var nativeTMXID = '';
    if ((_a = window.__EXPERIENCE_CONTEXT__) === null || _a === void 0 ? void 0 : _a.isConsumerApp) {
        nativeTMXID = getUrlParam('guid');
    }
    return nativeTMXID || ((_c = (_b = window.THD_ACCOUNT_LIB) === null || _b === void 0 ? void 0 : _b.TMX) === null || _c === void 0 ? void 0 : _c.getTMXsessionId());
};
/**
 * Functions used for userState, policy, trails and enrollment
 * set for left nav within server.js
 */
export var transformToTrialsObj = function (_a) {
    var _b;
    var data = _a.data;
    var trials = {};
    (_b = data === null || data === void 0 ? void 0 : data.features) === null || _b === void 0 ? void 0 : _b.forEach(function (feature) {
        trials[feature] = true;
    });
    return trials;
};
export var filterOutPII = function (_a) {
    var data = _a.data;
    var 
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    firstName = data.firstName, 
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    lastName = data.lastName, 
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    phoneNumber = data.phoneNumber, 
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    email = data.email, 
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    userAddress = data.userAddress, customer = data.customer, needed = __rest(data, ["firstName", "lastName", "phoneNumber", "email", "userAddress", "customer"]);
    var 
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    customerPhone = customer.phoneNumber, 
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    accountName = customer.accountName, neededFromCustomer = __rest(customer, ["phoneNumber", "accountName"]);
    return __assign(__assign({}, needed), { customer: __assign({}, neededFromCustomer) });
};
// Checks if the current environment is not SSR.
export var getWindow = function () {
    if (typeof window !== 'undefined') {
        return window;
    }
    return undefined;
};
/**
 * Returns a simplified date string in the format: Month Day, Year.
 *
 * @param date - The date string in ISO 8601 format.
 * @returns The simplified date string.
 */
export var getSimplifiedDate = function (date) {
    if (!date)
        return '';
    var dateValue = new Date("".concat(date, "T00:00:00Z"));
    var simplifiedDate = dateValue.toLocaleDateString('en-US', {
        timeZone: 'UTC',
        year: 'numeric',
        month: 'long',
        day: 'numeric',
    });
    return simplifiedDate;
};
export var roundValueAndTrim = function (value, decimalPlaces) {
    if (decimalPlaces === void 0) { decimalPlaces = 3; }
    return value.toFixed(decimalPlaces).replace(/\.?0+$/, '');
};
export var getStep = function (currentStep) {
    switch (currentStep) {
        case 'ReturnMethod':
            return FlowReturnMethodStep;
        case 'ItemsToReturn':
            return FlowItemsToReturnStep;
        case 'RefundMethod':
            return FlowRefundMethodStep;
        case 'DropOffBoxes':
            return FlowDropOffBoxesStep;
        case 'LORPContactDetails':
            return FlowLORPContactDetailsStep;
        case 'LORPWhatToExpect':
            return FlowLORPWhatToExpectStep;
        case 'LORPUserAcknowledge':
            return FlowLORPUserAcknowledgeStep;
        default:
            return FlowReturnMethodStep;
    }
};
export var getNextStep = function (currentStep, returnMethod) {
    switch (currentStep) {
        case 'ReturnMethod':
            return FlowItemsToReturnStep;
        case 'ItemsToReturn':
            return FlowDropOffBoxesStep;
        case 'DropOffBoxes':
            return FlowRefundMethodStep;
        case 'RefundMethod':
            if (returnMethod === RETURN_METHOD.LORP)
                return FlowLORPContactDetailsStep;
            return FlowFinalizeReturnStep;
        case 'LORPContactDetails':
            return FlowLORPWhatToExpectStep;
        case 'LORPWhatToExpect':
            return FlowLORPUserAcknowledgeStep;
        case 'LORPUserAcknowledge':
            return FlowFinalizeReturnStep;
        default:
            return FlowReturnMethodStep;
    }
};
export var getPreviousStep = function (currentStep, returnMethod) {
    switch (currentStep) {
        case 'ReturnMethod':
            return FlowReturnMethodStep;
        case 'ItemsToReturn':
            return FlowReturnMethodStep;
        case 'DropOffBoxes':
            return FlowItemsToReturnStep;
        case 'RefundMethod':
            return FlowDropOffBoxesStep;
        case 'LORPContactDetails':
            return FlowRefundMethodStep;
        case 'LORPWhatToExpect':
            return FlowLORPContactDetailsStep;
        case 'LORPUserAcknowledge':
            return FlowLORPWhatToExpectStep;
        case 'FinalizeReturn':
            if (returnMethod === RETURN_METHOD.LORP)
                return FlowLORPUserAcknowledgeStep;
            return FlowRefundMethodStep;
        default:
            return FlowReturnMethodStep;
    }
};
/**
 * Returns all the text that a component renders. Rarely used, only for getting analytics error message since we return a component, not a string.
 * Has a try catch just in case it errors something out and we don't want to break the page.
 * @param component - The component to extract text from.
 * @returns The text from the component.
 */
export var getTextFromComponent = function (component) {
    try {
        return extractTextFromComponent(component);
    }
    catch (error) {
        return '';
    }
};
function extractTextFromComponent(component) {
    var _a;
    var text = '';
    if ((_a = component === null || component === void 0 ? void 0 : component.props) === null || _a === void 0 ? void 0 : _a.children) {
        var children = Array.isArray(component.props.children)
            ? component.props.children
            : [component.props.children];
        children.forEach(function (child) {
            if (typeof child === 'string') {
                text += child;
            }
            else if (typeof child === 'object' && child.props) {
                text += extractTextFromComponent(child);
            }
        });
    }
    return text;
}
export var triggerQualtricsSurvey = function () {
    return setTimeout(function () {
        var _a, _b, _c;
        if ((window === null || window === void 0 ? void 0 : window.QSI) && ((_a = window === null || window === void 0 ? void 0 : window.QSI) === null || _a === void 0 ? void 0 : _a.API)) {
            (_b = window === null || window === void 0 ? void 0 : window.QSI) === null || _b === void 0 ? void 0 : _b.API.load();
            (_c = window === null || window === void 0 ? void 0 : window.QSI) === null || _c === void 0 ? void 0 : _c.API.run();
        }
    }, 3000);
};
export var redirectToOrderDetails = function (orderDetailsPath, isGuest) {
    var url = isGuest ? '/myaccount/guest-order-tracking' : orderDetailsPath;
    window.location.href = url;
};
// Format a phone number to the format (XXX) XXX-XXXX as user types it into the input
export var formatPhoneNumber = function (phoneNumberDigits) {
    if (!phoneNumberDigits)
        return '';
    // Remove all non-digit characters
    var numbers = phoneNumberDigits.replace(/\D/g, '').slice(0, 10);
    var len = numbers.length;
    if (len < 4)
        return numbers;
    if (len < 7)
        return "(".concat(numbers.slice(0, 3), ") ").concat(numbers.slice(3));
    return "(".concat(numbers.slice(0, 3), ") ").concat(numbers.slice(3, 6), "-").concat(numbers.slice(6));
};
export var scrollToTop = function (ref) {
    var _a;
    if (!ref)
        window.scrollTo(0, 0);
    else
        (_a = ref === null || ref === void 0 ? void 0 : ref.current) === null || _a === void 0 ? void 0 : _a.scrollTo(0, 0);
};
export var dateFormat = function (date, format, localTimezone) {
    if (date === undefined || date === null || date === '')
        return '';
    var dateTime = DateTime.fromISO(date, { zone: 'utc' });
    if (localTimezone) {
        var localZone = DateTime.local().zoneName;
        dateTime = dateTime.setZone(localZone);
    }
    return dateTime
        .toFormat(format)
        .replace('Tue', 'Tues')
        .replace('Thu', 'Thurs');
};
